import { render, staticRenderFns } from "./ChatGroupPhoto.vue?vue&type=template&id=faef16e8&"
import script from "./ChatGroupPhoto.vue?vue&type=script&lang=js&"
export * from "./ChatGroupPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports